import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { FigCaption } from 'pages/license/style';
import { ButtonWrap } from 'pages/settings_page/style';
import { useDispatch, useSelector } from 'react-redux';
import { refreshToken } from 'redux/slices/authSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { addAttribute, checkAttribute, getAttributes } from 'redux/slices/userSlice';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import {
  Box,
  BoxConatiner,
  BoxHeadItem,
  BoxListItem,
  BoxListWrap,
  Container,
  FormFieldWrap,
  FormWrap,
  Header,
  InputContainer,
  InputField,
  LeftBoxConatiner,
  LeftBoxWrap,
  List,
  SearchWrap,
  TransferButton,
  TransferContainer,
  UserFieldWrap,
} from './style';

export default function UserFields({ ...record }) {
  const dispatch = useDispatch();
  const [rightItems, setRightItems] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [selectedRightItems, setSelectedRightItems] = useState([]);
  const { userAttributes } = useSelector((state) => state.getUsers);

  useEffect(() => {
    setRightItems(userAttributes);
  }, [userAttributes]);

  useEffect(() => {
    dispatch(getAttributes(record.id));
  }, []);

  const handleTransferToRight = async () => {
    const data = { attribute: inputValue, fqdn: record.fqdn };
    try {
      setLoading(true);
      const response = await dispatch(checkAttribute(data));
      if (response.payload && response.payload.status === 200) {
        setRightItems([...rightItems, inputValue]);
        setInputValue('');
      } else {
        SweetSweetAlert({ text: response.payload.data, icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFromRight = () => {
    dispatch(refreshToken());
    setRightItems(rightItems.filter((item) => !selectedRightItems.includes(item)));
    setSelectedRightItems([]);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await dispatch(addAttribute({ attribute: rightItems, domainId: record.id }));
      if (response.payload && response.payload.status === 200) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
        dispatch(getAttributes(record.id));
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };
  const filteredRightItems = rightItems.filter((item) => item.toLowerCase().includes(searchValue.toLowerCase()));

  return (
    <>
      {loading && <ModalOpenLoader />}
      <UserFieldWrap className='af-superadmin-userfields-wrap'>
        <FigCaption className='af-superadmin-userfields-caption'>
          ** You can add more user attributes that will be displayed under <b>Others</b> Tab
        </FigCaption>
        <Container className='af-superadmin-userfields-container'>
          <LeftBoxWrap className='af-superadmin-userfields-left-box-wrap'>
            <LeftBoxConatiner className='f-superadmin-userfields-left-box-conatiner'>
              <InputContainer className='af-superadmin-userfields-add-field-input-container'>
                <FormWrap className='af-input-userfields-attribute-form-wrap'>
                  <h3 className='af-input-userfields-attribute-title-head'>Add Attribute:</h3>
                  <FormFieldWrap className='af-input-userfields-attribute-form-field-wrap'>
                    <InputField
                      className='af-superadmin-userfields-add-field-input'
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                    />
                    <TransferContainer className='af-superadmin-userfields-button-container'>
                      <TransferButton
                        className='af-superadmin-userfields-transfer-button af-superadmin-userfields-transfer-button-add'
                        onClick={handleTransferToRight}
                        disabled={inputValue.length === 0}
                      >
                        Add
                      </TransferButton>
                      <TransferButton
                        className='af-superadmin-userfields-transfer-button af-superadmin-userfields-transfer-button-remove'
                        onClick={handleRemoveFromRight}
                        disabled={selectedRightItems.length === 0}
                      >
                        Remove
                      </TransferButton>
                    </TransferContainer>
                  </FormFieldWrap>
                </FormWrap>
              </InputContainer>
            </LeftBoxConatiner>
            <FigCaption className='af-superadmin-userfields-input-caption'>
              ** Make sure the attribute name matches exactly as in Active Directory.
            </FigCaption>
          </LeftBoxWrap>
          <BoxConatiner className='af-superadmin-userfields-right-box-conatiner'>
            <Box className='af-superadmin-userfields-right-wrap'>
              <Header className='af-superadmin-userfields-right-box-header'>
                <BoxHeadItem className='af-superadmin-userfields-right-box-header-name'>Added Attribute(s)</BoxHeadItem>
                <BoxHeadItem className='af-superadmin-userfields-right-box-header-listcount'>
                  {rightItems.length} Item(s)
                </BoxHeadItem>
              </Header>
              <SearchWrap className='af-superadmin-userfields-right-box-search-input-wrap'>
                <InputField
                  className='af-superadmin-userfields-right-box-search-input'
                  placeholder='Search...'
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </SearchWrap>
              <List className='af-superadmin-userfields-right-box-header'>
                {filteredRightItems.map((item, index) => (
                  <BoxListWrap
                    className={`af-superadmin-userfields-right-box-item-wrap af-superadmin-userfields-right-box-item-wrap-${item}`}
                    key={index}
                  >
                    <Checkbox
                      className={`af-superadmin-userfields-right-box-item-checkbox af-superadmin-userfields-right-box-item-checkbox-${item}`}
                      checked={selectedRightItems.includes(item)}
                      onChange={() =>
                        setSelectedRightItems(
                          selectedRightItems.includes(item)
                            ? selectedRightItems.filter((i) => i !== item)
                            : [...selectedRightItems, item]
                        )
                      }
                    >
                      <BoxListItem
                        className={`af-superadmin-userfields-right-box-item af-superadmin-userfields-right-box-item-${item}`}
                      >
                        {item}
                      </BoxListItem>
                    </Checkbox>
                  </BoxListWrap>
                ))}
              </List>
            </Box>
          </BoxConatiner>
        </Container>
        <ButtonWrap className='af-form-button-submit-wrapper af-userfields-form-button-submit-wrapper'>
          <StyledButton
            className='af-form-button af-userfields-form-button af-userfields-form-button_submit'
            type='primary'
            htmlType='submit'
            onClick={() => handleSubmit()}
            disabled={inputValue.length !== 0 || selectedRightItems.length !== 0}
          >
            Submit
          </StyledButton>
        </ButtonWrap>
      </UserFieldWrap>
    </>
  );
}
